import apiClient from './index';

export type MeterReadingImportError = {
  row_index: number;
  message: string;
  serial_number?: string | null;
  dev_eui?: string | null;
  reading_value?: string | null;
  reading_date?: string | null;
  file_name?: string | null;
};

export type MeterReadingImportResult = {
  total_rows: number;
  imported_rows: number;
  skipped_rows: number;
  batch_id?: string | null;
  group_id?: string | null;
  detected_format?: string | null;
  import_mode?: string | null;
  warnings: string[];
  errors: MeterReadingImportError[];
};

export type MeterReadingImportBatch = {
  id: string;
  group_id?: string | null;
  created_at?: string | null;
  created_by_user_id?: string | null;
  created_by_email?: string | null;
  file_name?: string | null;
  total_rows?: number | null;
  imported_rows?: number | null;
  skipped_rows?: number | null;
  rolled_back_at?: string | null;
  rolled_back_by_user_id?: string | null;
  rolled_back_by_email?: string | null;
};

export type MeterReadingImportBatchList = {
  items: MeterReadingImportBatch[];
  total: number;
};

export const meterReadingsImportApi = {
  async downloadTemplate(): Promise<Blob> {
    const response = await apiClient.get<Blob>('/meter-readings/import/template', {
      responseType: 'blob',
    });
    return response.data;
  },
  async uploadFile(file: File, options?: { import_mode?: 'current' | 'history'; upload_group_id?: string; building_id?: string }): Promise<MeterReadingImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    if (options?.import_mode) {
      formData.append('import_mode', options.import_mode);
    }
    if (options?.upload_group_id) {
      formData.append('upload_group_id', options.upload_group_id);
    }
    if (options?.building_id) {
      formData.append('building_id', options.building_id);
    }
    const response = await apiClient.post<MeterReadingImportResult>(
      '/meter-readings/import',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },
  async listBatches(params?: { limit?: number; offset?: number; q?: string; date_from?: string; date_to?: string; sort_by?: string; sort_dir?: string }): Promise<MeterReadingImportBatchList> {
    const response = await apiClient.get<MeterReadingImportBatchList>(
      '/meter-readings/import/batches',
      { params }
    );
    return response.data;
  },
  async rollbackBatch(batchId: string): Promise<MeterReadingImportBatch> {
    const response = await apiClient.post<MeterReadingImportBatch>(
      `/meter-readings/import/batches/${batchId}/rollback`
    );
    return response.data;
  },
  async exportBatches(params?: { q?: string; date_from?: string; date_to?: string; sort_by?: string; sort_dir?: string }): Promise<Blob> {
    const response = await apiClient.get<Blob>(
      '/meter-readings/import/batches/export',
      { params, responseType: 'blob' }
    );
    return response.data;
  },
};
